import axios from "axios";
 
export default axios.create({
  baseURL: "https://api2.scorekeeperwins.com/",
  // baseURL: "http://localhost:8088/",
  headers: {
    "Content-type": "application/json",
  }
});